import { AnimatedMetricCard } from '@/components/AnimatedMetricCard';
import { PlayerHighlights } from '@/components/PlayerHighlights';
import { useGlobalMetrics } from '@/hooks/useGlobalMetrics';
import { Trophy, Target, Clock, Zap, Calendar, Hand } from 'lucide-react';

export function GlobalMetricsSection() {
  const { data: metrics, isLoading } = useGlobalMetrics();

  const metricCards = [
    {
      title: 'Sessions Completed',
      value: metrics?.totalSessions || 0,
      suffix: '',
      description: 'Total training sessions',
      icon: <Target className="h-6 w-6" />,
      gradient: 'bg-gradient-to-br from-[#ffffff] to-[#fbfcfc]',
      iconColor: 'text-[#0248c1]'
    },
    {
      title: 'Training Hours',
      value: Math.round(metrics?.equivalentTrainingHours || 0),
      suffix: '+ hrs',
      description: 'Equivalent group practice',
      icon: <Zap className="h-6 w-6" />,
      gradient: 'bg-gradient-to-br from-[#ffffff] to-[#fbfcfc]',
      iconColor: 'text-[#0248c1]'
    },
    {
      title: 'Full Practices',
      value: metrics?.fullPracticesGained || 0,
      suffix: '',
      description: 'Gained through training',
      icon: <Calendar className="h-6 w-6" />,
      gradient: 'bg-gradient-to-br from-[#ffffff] to-[#fbfcfc]',
      iconColor: 'text-[#f8d613]'
    },
    {
      title: 'Total Touches',
      value: metrics?.totalTouches || 0,
      suffix: '',
      description: 'Ball touches in training',
      icon: <Hand className="h-6 w-6" />,
      gradient: 'bg-gradient-to-br from-[#ffffff] to-[#fbfcfc]',
      iconColor: 'text-[#0248c1]'
    }
  ];

  return (
    <section className="py-16 px-4 bg-[#fbfcfc]">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-[#111835]">
          Our Impact
        </h2>
        
        <PlayerHighlights />
        
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {metricCards.map((card, index) => (
            <AnimatedMetricCard
              key={card.title}
              title={card.title}
              value={card.value}
              suffix={card.suffix}
              description={card.description}
              icon={card.icon}
              isLoading={isLoading}
              gradient={card.gradient}
              iconColor={card.iconColor}
              delay={index}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
